import { Grid, List, NavBar, Popup, ProgressBar, Rate } from 'antd-mobile'

import { 
    BodyView,
    ListView
} from "./factory/ViewUtil";
import { LogoIconR } from './icons';
import { ArrowDownCircleOutline, CheckShieldFill, CompassOutline } from 'antd-mobile-icons'
import React, { useEffect, useState } from 'react';
import { RequestAppInfo } from '../NetworkFactory';
import { CellStateView } from './factory/CellViews';
import { IOSVersion, AndroidVersion, ToastContent } from './factory/FactoryUtil';

const AppViewController = ({goback, data}) => {

    const type = data.ios === true ? 'ios' : 'android'
    const [stateCode, setStateCode] = useState(3);
    const [dataSource, setDataSource] = useState({});
    const [visible, setVisible] = useState(false);
    const [downloadData, setDownloadData] = useState({});
    
    const requestData = () => {
        setStateCode(3)
        RequestAppInfo().then(response => {
            const data = response.data || {}
            setStateCode(Object.keys(data).length >0 ? -1 : 1)
            setDataSource(data)
        }).catch(()=> {
            setStateCode(1)
        })
    }

    useEffect(() => {
        requestData()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // # 
    const dd = (type = 'android') => {
        const data = dataSource[type].download || {}
        let configData = []
        const dv = dataSource[type].compatibility
        Object.values(data).forEach(item => {
            if(item.url.length > 6) {
                let ds = type + ' >= ' + dv
                if(item.version) {
                    const c = item.c || '0'
                    if(c === '1') {
                        ds = type + ' < ' + item.version
                    }
                    else if(c === '2') {
                        ds = type + ' >= ' + item.version
                    }
                }
                configData.push({...item, dv, ds})
            }
        })

        if(configData.length === 0) {
            ToastContent('Not found download url')
        }
        else if(configData.length === 1) {
            // # 只有一个下载地址直接跳转到地址
            openDownlaod(configData[0])
        }
        else {
            setVisible(true)
            let sysv = 0
            let ios = IOSVersion();
            let android = AndroidVersion()
            let sys = ''
            if(ios > 0) {
                sysv = ios
                sys = 'iOS'
            } else if(android > 0) {
                sysv = android
                sys = 'Android'
            }
            setDownloadData({
                name : type,
                sys : sys,
                sysVersion : sysv,
                data : configData
            })
        }
    }

    const goAndroid = () => {
        dd('android')
    }

    const goIOS = () => {
        dd('ios')
    }

    const openDownlaod = (item) => {
        //setVisible(false);
        window.location.href = item.url;
        //window.open(url)
    }

    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>App Download</NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
                <ListView>
                    <CellStateView stateType={stateCode} onRefresh={()=>{requestData()}}/> 
                    {
                        Object.keys(dataSource).length > 0 ? (
                        <>
                            <List.Item style={{marginTop : '20px'}}>
                            <div style={{
                                display : 'flex',
                                alignItems : 'center'
                                }}>
                                    <div style={{
                                        width : '92px', 
                                        height : '92px',
                                    }}><LogoIconR/></div>
                                    <div style={{width : '10px'}}></div>
                                    <div style={{
                                        flex : '1'
                                    }}>
                                        <div>
                                            <div style={{fontWeight : 'bold'}}>Enxbit <CheckShieldFill color='#32BC70'/></div>
                                            <div style={{fontSize : '13px', color : '#999', margin : '2px 0'}}>Crypto assets</div>
                                            <div style={{height : '4px'}}></div>
                                            <Grid columns={2} gap={10} style={{
                                                    textAlign : 'center',
                                                    fontSize : '14px',
                                                    color : '#FFF',
                                                    fontWeight : 'bold'
                                                }}>
                                                <Grid.Item onClick={goAndroid} style={{
                                                    background : "#32BC70",
                                                    padding : '8px 0',
                                                    borderRadius : '100px',
                                                    wordBreak : 'break-word'
                                                }}>Android <ArrowDownCircleOutline/></Grid.Item>
                                                <Grid.Item onClick={goIOS} style={{
                                                    background : '#222',
                                                    padding : '8px 0',
                                                    borderRadius : '100px'
                                                }}>iOS <CompassOutline/></Grid.Item>
                                            </Grid>
                                        </div>
                                    </div>
                            </div>
                            </List.Item>
                            <List.Item style={{marginTop : '30px'}}>
                                <div style={{
                                    display : 'flex',
                                    alignItems : 'center',
                                    fontSize : '12px'
                                }}>
                                    <div style={{flex : '1'}}>
                                        <div style={{display : 'flex', alignItems : 'center'}}>
                                            <div style={{fontWeight : 'bold', fontSize : '16px'}}>4.9</div>
                                            <div style={{width : '2px'}}></div>
                                            <Rate readOnly value={5} style={{'--star-size' : '10px', '--active-color' : '#666'}}/>
                                        </div>
                                        <div style={{color : 'rgba(0,0,0,0.2)'}}>9999+scores</div>
                                    </div>
                                    <div style={{textAlign : 'right'}}>
                                        <div style={{fontWeight : 'bold', fontSize : '16px'}}>{dataSource[type].age}</div>
                                        <div style={{color : 'rgba(0,0,0,0.2)'}}>Age</div>
                                    </div>
                                </div>
                            </List.Item>
                            <List.Item style={{marginTop : '20px'}}>
                                <div style={{padding : '10px 0', fontWeight : 'bold', fontSize : '20px', wordBreak : 'break-word'}}>Ratings & comments</div>
                                <div style={{display : 'flex', alignItems : 'center'}}>
                                    <div style={{textAlign : 'center', minWidth : '100px'}}>
                                        <div style={{fontSize : '50px', fontWeight : 'bold'}}>4.9</div>
                                        <div style={{fontSize : '12px', color : '#999'}}>Full score is 5</div>
                                    </div>
                                    <div style={{width : '20px'}}></div>
                                    <div style={{flex : '1'}}>
                                        <div style={{display : 'flex', alignItems : 'center'}}>
                                            <Rate readOnly value={0} style={{'--star-size' : '10px', '--active-color' : 'transparent', '--inactive-color' : '#666'}}/>
                                            <div style={{width : '6px'}}></div>
                                            <ProgressBar percent={90}style={{flex : '1','--track-width': '2px', '--fill-color' : '#666'}}/>
                                        </div>
                                        <div style={{display : 'flex', alignItems : 'center'}}>
                                            <Rate readOnly value={0} style={{'--star-size' : '10px', '--active-color' : 'transparent', '--inactive-color' : '#666'}}/>
                                            <div style={{width : '6px'}}></div>
                                            <ProgressBar percent={30}style={{flex : '1','--track-width': '2px', '--fill-color' : '#666'}}/>
                                        </div>
                                        <div style={{display : 'flex', alignItems : 'center'}}>
                                            <Rate readOnly value={1} style={{'--star-size' : '10px', '--active-color' : 'transparent', '--inactive-color' : '#666'}}/>
                                            <div style={{width : '6px'}}></div>
                                            <ProgressBar percent={0}style={{flex : '1','--track-width': '2px', '--fill-color' : '#666'}}/>
                                        </div>
                                        <div style={{display : 'flex', alignItems : 'center'}}>
                                            <Rate readOnly value={2} style={{'--star-size' : '10px', '--active-color' : 'transparent', '--inactive-color' : '#666'}}/>
                                            <div style={{width : '6px'}}></div>
                                            <ProgressBar percent={0}style={{flex : '1','--track-width': '2px', '--fill-color' : '#666'}}/>
                                        </div>
                                        <div style={{display : 'flex', alignItems : 'center'}}>
                                            <Rate readOnly value={3} style={{'--star-size' : '10px', '--active-color' : 'transparent', '--inactive-color' : '#666'}}/>
                                            <div style={{width : '6px'}}></div>
                                            <ProgressBar percent={0}style={{flex : '1','--track-width': '2px', '--fill-color' : '#666'}}/>
                                        </div>
                                    </div>
                                </div>
                            </List.Item>
                            <List.Item style={{marginTop : '30px'}}>
                                <div style={{fontSize : '17px', fontWeight : 'bold'}}>Brief introducation</div>
                                <div style={{fontSize : '14px', marginTop : '6px', wordBreak : 'break-word'}}>
                                {dataSource[type].about.en}
                                </div>
                            </List.Item>
                            <List.Item style={{marginTop : '30px', fontSize : '12px'}}>
                                <div style={{fontSize : '17px', fontWeight : 'bold'}}>Informaction</div>

                                <div style={{display : 'flex', alignItems : 'center', margin : '20px 0'}}>
                                    <div style={{flex : '1', color : '#999'}}>Version</div>
                                    <div>{dataSource[type].version}</div>
                                </div>

                                <div style={{display : 'flex', alignItems : 'center', margin : '20px 0'}}>
                                    <div style={{flex : '1', color : '#999'}}>Compatibility</div>
                                    <div>{type} {dataSource[type].compatibility}</div>
                                </div>

                                <div style={{display : 'flex', alignItems : 'center', margin : '20px 0'}}>
                                    <div style={{flex : '1', color : '#999'}}>Support Language</div>
                                    <div>{dataSource[type].language}</div>
                                </div>

                                <div style={{display : 'flex', alignItems : 'center', margin : '20px 0'}}>
                                    <div style={{flex : '1', color : '#999'}}>Size</div>
                                    <div>{dataSource[type].size}</div>
                                </div>

                                <div style={{display : 'flex', alignItems : 'center', margin : '20px 0'}}>
                                    <div style={{flex : '1', color : '#999'}}>Update time</div>
                                    <div>{dataSource[type].update}</div>
                                </div>
                            </List.Item>
                            <List.Item style={{
                                margin : '20px 0 100px 0', 
                                fontSize : '12px',
                                textAlign : 'center',
                                color : '#999'
                                }}>
                                Copyright @ ocs. All Rights Reserved
                            </List.Item>
                        </>) : ''
                    }
                </ListView>

                <Popup
                    visible={visible}
                    onMaskClick = {()=>{setVisible(false)}}
                    bodyStyle={{
                        borderTopLeftRadius: '16px',
                        borderTopRightRadius: '16px',
                        fontSize : '17px',
                        color : '#000'
                    }}
                >
                    <div style={{textAlign : 'center', padding : '15px 0', borderBottom : '1px #eee solid'}}>
                        <div style={{fontWeight : 'bold'}}>Please select channel</div>
                        {
                            downloadData.sysVersion > 0 ? (
                                <div style={{
                                    color : '#999',
                                    marginTop : '6px',
                                    textAlign : 'center', 
                                    fontSize : '13px'}}>
                                    Your <b style={{color : '#6094FF'}}>{downloadData.sys}</b> device version : <b style={{color : '#6094FF'}}>{downloadData.sysVersion}</b>
                                </div>) : ''
                        }
                    </div>
                    
                    <div style={{maxHeight : '45vh', padding : '15px', overflowY : 'auto'}}>
                        <ListView>

                            {
                                (downloadData.data || []).map((item, index) => (
                                    <List.Item 
                                        arrowIcon={false}
                                        onClick={()=>{
                                            openDownlaod(item)
                                        }}
                                        key={index} 
                                        className='cellCardBorder'
                                        extra={downloadData.name === 'android' ? <ArrowDownCircleOutline color='#32BC70' fontSize={20}/> : <CompassOutline color='#333' fontSize={20}/>}>
                                        <div style={{marginBottom : '6px', fontSize : '16px'}}>Download ({index+1})</div>
                                        <div style={{fontSize : '12px', color : '#6094FF', marginBottom : '3px'}}>{item.ds}</div>
                                        <div style={{fontSize : '12px', color : '#999'}}>{item.url}</div>
                                    </List.Item>
                                ))
                            }

                            <List.Item style={{
                                textAlign : 'center', 
                                fontSize : '14px', 
                                color : '#666',
                                wordBreak : 'break-word',
                                margin : '20px 0'
                            }}>
                                <div>Support channel ({(downloadData.data || []).length})</div>
                                <div style={{fontSize : '10px', marginTop : '4px'}}>App size : {(dataSource[downloadData.name] || {}).size}</div>
                            </List.Item>
                        </ListView>
                    </div>
            </Popup>
            </BodyView>
        </>
    );
}
export default React.memo(AppViewController)